(function () {
  // Read <ul id="variant-inventory-{{ product.id }}"> with <li data-*>
  function readInventoryMap(productId) {
    var root = document.getElementById("variant-inventory-" + productId);
    if (!root) return null;
    var map = {};
    root.querySelectorAll("li[data-id]").forEach(function (li) {
      var id = String(li.dataset.id);
      map[id] = {
        qty: parseInt(li.dataset.qty || "0", 10),
        managed: li.dataset.managed || "",                 // 'shopify' or ''
        available: li.dataset.available === "true",        // boolean
        policy: li.dataset.policy || ""                    // 'deny' | 'continue'
      };
    });
    return map;
  }

  function currentVariantId(scope) {
    var input = (scope || document).querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function updateOne(el) {
    var productId = el.getAttribute("data-product-id");
    if (!productId) return;

    var map = readInventoryMap(productId);
    if (!map) return;

    // Prefer the same product column as the alert (handles sticky/quick-buy too)
    var section = el.closest('[id^="product-info-"]') || document;
    var vid = currentVariantId(section);
    if (!vid) return;

    var row = map[vid];
    var qty = row ? row.qty : 0;
    var threshold = parseInt(el.dataset.threshold || "2", 10);

    // Show when tracked by Shopify, available, and qty within 1..threshold
    var show = !!row && !!row.managed && row.available && qty > 0 && qty <= threshold;

    var text = el.querySelector(".low-stock-alert__text");
    if (text) text.textContent = qty === 1
      ? "Hurry! Only 1 left in stock!"
      : "Hurry! Only " + qty + " left in stock!";
    el.hidden = !show;
  }

  function updateAll() {
    document.querySelectorAll('[id^="LowStockAlert-"]').forEach(updateOne);
  }

  function bind() {
    // Theme variant change event
    document.addEventListener("variant:change", updateAll);

    // Directly watch the variant id inputs
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
      input.addEventListener("change", updateAll);
      input.addEventListener("input", updateAll);
    });

    // DOM swaps from <product-rerender>, drawers, etc.
    var obs = new MutationObserver(function () { setTimeout(updateAll, 0); });
    obs.observe(document.body, { childList: true, subtree: true });

    // Initial runs
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", updateAll);
    } else {
      updateAll();
    }
    window.addEventListener("load", updateAll);
  }

  bind();
})();
